import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from './cn';

/**
 * Textarea — Design System v2 (extensão do §5.input).
 *
 * Mesmo visual do {@link Input}, sem suporte a ícone (não há slot natural)
 * mas mantendo paddings consistentes. Counter fica no {@link Field}.
 */

type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

const BASE =
  'w-full min-h-[88px] rounded-md border border-border-strong bg-bg-surface-v2 px-[14px] py-2.5 font-body text-[14px] leading-snug text-text-primary placeholder:text-text-faint-v2 transition-all focus:outline-none focus:border-primary focus:shadow-ring disabled:opacity-60 disabled:cursor-not-allowed resize-y';

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, rows = 3, ...rest },
  ref,
) {
  return <textarea ref={ref} rows={rows} className={cn(BASE, className)} {...rest} />;
});
